<div style="display: flex; height: 50px;" >
    <h1 style="flex:80%">{{passedConfig.title}}</h1>
    <div class="step-over-6" style="flex:50%">
        {{step}}/7
    </div>
</div>

<ng-container *ngIf="!passedConfig.multiEdit">
    <app-crudbuilder
            [config]="passedConfig"
            [model]="passedConfig.model"
            [err]="passedConfig.errors"
            design="wizard"
    >
    </app-crudbuilder>
</ng-container>

<ng-container *ngIf="passedConfig.multiEdit">

    <ng-container *ngFor="let model of passedConfig.models; let i = index;">
        <app-crudbuilder
                [config]="passedConfig"
                [model]="passedConfig.models[i]"
                [err]="passedConfig.manyErrors[i]"
                design="wizard"
        >
        </app-crudbuilder>
        
        <div *ngIf="i === (passedConfig.models.length - 1) && !model.id" class="delete-button-wrapper">
            <ion-button (click)="remove(i)" class="delete-button" color="transparent">
                Verwijderen {{passedConfig.singular}}
            </ion-button>
        </div>

        <div class="divider" *ngIf="i != passedConfig.models.length - 1"></div>
    </ng-container>

    <ion-button (click)="add()" class="add-button" color="transparent">
        Voeg {{passedConfig.singular}} Toe &nbsp;<i [class]="generateButtonClass()"></i>
    </ion-button>
</ng-container>
